import { logWarn, type Maybe } from '@amazon/vinyl-util'
import { type PlayableEntity } from '@/service/fragments/playableEntityFrag'
import type { PlaylistEntry } from '@/playback/PlaylistController'
import { trackToPlaylistEntry } from '@/track/trackGqlUtil'
import { podcastEpisodeToPlaylistEntry } from '@/podcast/podcastEpisodeGqlUtil'
import { audiobookToPlaylistEntry } from '@/playback/audiobookToPlaylistEntry'
import { advertisementToPlaylistEntry } from '@/playback/advertisementToPlaylistEntry'
import { ctx } from '@/util/context'

const { target } = ctx('playableEntityToPlaylistEntry')

// TODO: handle 'Interlude'

export function playableEntityToPlaylistEntry(
    element: Maybe<PlayableEntity | { __typename: 'Audiobook' | 'Interlude' | null }>
): PlaylistEntry | null {
    if (element?.__typename === 'Track') {
        return trackToPlaylistEntry(element)
    } else if (element?.__typename === 'PodcastEpisode') {
        return podcastEpisodeToPlaylistEntry(element)
    } else if (element?.__typename === 'Advertisement') {
        return advertisementToPlaylistEntry(element)
    } else if (element?.__typename === 'Audiobook' && 'playParams' in element) {
        // The cloud-queue node union carries a bare `{ __typename: 'Audiobook' }`
        // (audiobooks are never queued — they play Audible-SDK-only); only the
        // full-fields shape from `audiobookFields` is convertible.
        return audiobookToPlaylistEntry(element)
    } else {
        logWarn(target, 'Unhandled type:', element?.__typename)
        return null
    }
}
